export const isSirfAvailable = (subsidizedFares) => {
    return subsidizedFares.findIndex(({ type }) => type === "SPANISH_RESIDENT_FARE") !== -1;
};
export const getSirfStatus = (subsidizedFares) => {
    if (subsidizedFares.findIndex(({ type }) => type === "SPANISH_RESIDENT_FARE") !== -1)
        return "SPANISH_RESIDENT_FARE";
    if (subsidizedFares.findIndex(({ type }) => type === "NO_SIRF_SUBSIDY") !== -1)
        return "NO_SIRF_SUBSIDY";
    return undefined;
};
export const isSirfApplied = (subsidizedFareTypes) => {
    return subsidizedFareTypes.includes("SPANISH_RESIDENT_FARE");
};
export const getSirfInfo = (subsidizedFares) => {
    return subsidizedFares.find(({ type }) => type === "SPANISH_RESIDENT_FARE");
};
export const getPassengerSirfData = (subsidizedFareTravelDocuments) => {
    return subsidizedFareTravelDocuments.find(({ subsidizedFareType }) => subsidizedFareType === "SPANISH_RESIDENT_FARE");
};
export const getMunicipalityData = (municipalityCode, municipalities) => {
    return municipalities.find(({ code }) => code === municipalityCode);
};
export const areAllPassengerSirfDocsVerified = (order) => {
    const { passengers } = order;
    const areAllVerified = passengers.every(({ subsidizedFareTravelDocuments }) => {
        const sirfDoc = subsidizedFareTravelDocuments?.find(({ subsidizedFareType }) => subsidizedFareType === "SPANISH_RESIDENT_FARE");
        return Boolean(sirfDoc && sirfDoc.status === "VERIFIED");
    });
    return areAllVerified;
};
